import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'
import { getMessaging } from 'firebase/messaging'
import {getAnalytics, logEvent} from 'firebase/analytics';

// Import ENV config
import config from '../../config'
 
const firebaseConfig = {
    apiKey: config.firebase.apiKey,
    authDomain: config.firebase.authDomain,
    projectId: config.firebase.projectId,
    storageBucket: config.firebase.storageBucket,
    messagingSenderId: config.firebase.messagingSenderId,
    appId: config.firebase.appId,
    measurementId: config.firebase.measurementId,
  };


const app = initializeApp(firebaseConfig)

export const firestoreDb = getFirestore()
export const storage = getStorage()
export const messaging = getMessaging();
export const analytics = getAnalytics(app);
export const LogEvent = logEvent;